/**
 * Whether billing / subscription surfaces are active in this environment.
 *
 * Env-driven switch: billing is on only when `VITE_BILLING_ENABLED` is exactly
 * `"true"` at build time. Any other value (unset, `"false"`, a typo) leaves
 * billing off — every billing surface stays hidden and the paywall is bypassed,
 * so the app is always fully usable when billing is disabled.
 *
 * Reads a build-time constant, so the value is stable for the whole session:
 * safe to call directly inside `<Show>` / `createMemo` without a signal.
 */
export function isBillingEnabled(): boolean {
  return import.meta.env.VITE_BILLING_ENABLED === "true";
}
